const tableContainerClassName = 'table-container';

const init = () => {
    addContainers();
};

const addContainers = () => {
    const tables = document.querySelectorAll('.article__content table');
    for (let i=0; i<tables.length; i++) {
        const table = tables[i];

        // Don't wrap tables that are already in a container.
        if (insideTableContainer(table)) continue;

        // Don't wrap the crayon code examples.
        if (table.classList.contains('crayon-table')) continue;

        const container = document.createElement('div');
        container.classList.add(tableContainerClassName);
        table.parentNode.insertBefore(container, table);
        container.appendChild(table);
    }
}

/**
 * Loop through an elements parent elements checking to see 
 * if they're already inside a table container.
 * 
 * @param {HTMLElement} table The table to check against.
 * @return {boolean} Whether the element is inside a table container.
 */
const insideTableContainer = table => {
    let insideContainer = false;
    let tableParentElement = table.parentElement;

    while (tableParentElement) {
        if (tableParentElement.classList.contains(tableContainerClassName)) {
            insideContainer = true;
            break;
        }
        tableParentElement = tableParentElement.parentElement;
    }
    
    return insideContainer;
}

export default {
    init
};